import {Component, OnInit} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {Store} from '@ngrx/store';
import {AppState} from '../../../../store';
import {StudentEnrollmentWizardComponent} from '../student-enrollment-wizard/student-enrollment-wizard.component';
import {TenantService} from '../../../../services/tenant.service';
import {Tenant} from '../../../../models/tenant.model';
import {selectUser} from '../../../../store/selectors';
import {User} from '../../../../models/user.model';
import {Subscription} from 'rxjs';
import {SchoolUsersDbService} from '../../../../services/school-users-db.service';

@Component({
    selector: 'student-enrolment-dialog-container',
    imports: [],
    templateUrl: './student-enrolment-dialog-container.component.html',
    styleUrl: './student-enrolment-dialog-container.component.scss'
})
export class StudentEnrolmentDialogContainerComponent implements OnInit {
  private tenant: Tenant;
  private user: User;
  private dialogOpen: boolean;
  private subs$: Subscription;

  constructor(private dialog: MatDialog,
              private tenantService: TenantService,
              private store: Store<AppState>,
              private users: SchoolUsersDbService,
  ) {
    this.tenant = tenantService.tenant
  }


  ngOnInit(): void {

    this.subs$ = this.store.select(selectUser).subscribe(user => {

      if(this.dialogOpen) {
        return
      }

      this.users.findUserByTenantAndId(this.tenant.id, user.id).subscribe(user => {

            this.user = user

            console.log('StudentEnrolmentDialogContainerComponent',user, this.tenantService.tenant)

            if (user && this.tenant && this.tenant.studentEnrollmentSettings && this.tenant.studentEnrollmentSettings?.enabled) {

            const studentEnrollmentSettings = this.tenant.studentEnrollmentSettings;

            if (studentEnrollmentSettings?.whenToAsk === 'onNextOrInitialLogin') {
              this.onNextOrInitialLogin();
            } else if (studentEnrollmentSettings?.whenToAsk === 'afterFirstPaymentOnly') {
              this.afterFirstPaymentOnly();
            }

          }
      })

    })

  }

  onNextOrInitialLogin() {

    // if there is no user.studentEnrollment meaning enrollment is not completed, and the we are on next or initial log, show the popup, and that's it, as simple as that

    if (!this.user?.studentEnrollment) {
      this.openWizardDialog()
    }


  }

  afterFirstPaymentOnly() {
    // I think we need a user.firstPaymentMade flag, and use that, as simple as that for showing the dialog
    if(this.user?.firstPaymentMade && !this.user?.studentEnrollment) {

      this.openWizardDialog()

    }

  }

  openWizardDialog() {

    const tenant = this.tenantService.tenant;
    const studentEnrolmentSettings = tenant?.studentEnrollmentSettings;

    const dialogRef = this.dialog.open(StudentEnrollmentWizardComponent, {
      width: '600px',
      disableClose: true,
      data: {
        studentEnrolmentSettings: studentEnrolmentSettings,
        preview: false
      },
    });

    this.dialogOpen = true;

    dialogRef.afterClosed().subscribe(result => {
      this.dialogOpen = false;
    })

  }

}
